/** @format */

import store from "../store";
import Auth from "../Auth";

export default ({ to, from, next }) => {
  if (Auth.check() == false) {
    next("/login");
    return false;
  }
  // else if (Auth.user.role != 1) {
  //   next("/login");
  //   return false;
  // }
  next();
};
